import { nextTick, ref } from 'vue'
import { getCombinationList } from '@/apis/combined'
import { useRoute } from 'vue-router'
import { formatCombinationProduct } from './useCombinedProduct'

export const formatCombinationProductSku = (v: any, rate: number) => ({
  ...v,
  id: v.combinationProductSku,
  code: v.combinationProductSku,
  name: v.combinationProductName,
  img: v.combinationProductMainImg,
  combinationProductProp: v.combinationProductProp,
  type: 'combination',
  price: v.productSellPrice ?? 0,
  PriceJpy: (v.productSellPrice ?? 0) * rate ? Math.floor((v.productSellPrice ?? 0) * rate) : 0
})

export default (productCode: any, productList: any, rate: any, emits: any) => {
  const list: any = ref([])
  const loading: any = ref(false)
  const route = useRoute()
  const getList = () => {
    if (productCode.value) {
      const row = productList.value.find((e:any) => e.combinationProductSku === productCode.value)
      list.value = [formatCombinationProductSku(row, rate.value)]
      nextTick(() => {
        emits('update:skuList', list.value)
      })
      return
    }
    if (route.query?.combinationProductSku) {
      loading.value = true
      emits('update:skuLoading', true)
      getCombinationList({ keywordSku: route.query.combinationProductSku }).then(res => {
        list.value = [formatCombinationProductSku(res.data.records[0], rate.value)]
        console.log('list.value', [formatCombinationProduct(res.data.records[0], rate.value)])
        nextTick(() => {
          emits('update:skuList', list.value)
          emits('getSkuData', route.query.combinationProductSku)
          emits('getData', formatCombinationProduct(res.data.records[0], rate.value))
        })
      }).finally(() => {
        loading.value = false
        emits('update:skuLoading', false)
      })
    }
  }

  return [
    loading,
    list,
    getList
  ]
}
